import React from 'react';
import { Column, FilterFnOption } from '@tanstack/react-table';
import DefaultTableFilter from './DefaultTableFilter';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function TextFilter({ column }: { column: Column<any> }) {
	const { t } = useTranslation();
	return (
		<DefaultTableFilter id={column.id} active={!!column.getFilterValue()}>
			<div className="form-group">
				<Form.Control
					type="text"
					size="sm"
					placeholder={`${t('table.search')}...`}
					value={(column.getFilterValue() as string) || ''}
					onChange={(e) => column.setFilterValue(e.target.value || '')}
				/>
			</div>
		</DefaultTableFilter>
	);
}

export const textFilter: FilterFnOption<any> = (row, columnId, filterValue) => {
	return (row.original[columnId] || '').toLowerCase().includes((filterValue || '').toLowerCase());
};

export default TextFilter;
